export function getLastSavedStepIndex({ isResultStep, quizStep, settings, }) {
    var _a, _b;
    // Индекс технического шага 'seen' в БД
    const INIT_INDEX_STEP = -1;
    let lastSavedStepIndex = INIT_INDEX_STEP;
    if (!isResultStep) {
        const currentStepIndex = parseInt('' + quizStep);
        if (Number.isInteger(currentStepIndex)) {
            // -2 тк в данном компоненте еще считается начальный шаг
            // который не сохраняется в БД и у него индекс 0
            lastSavedStepIndex = currentStepIndex - 2;
        }
    }
    else {
        // -1 т.к. в settings.steps хранятся только шаги для заполнения
        // без начального шага приветствия и шага результата
        lastSavedStepIndex = ((_b = (_a = settings.steps) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) - 1;
    }
    lastSavedStepIndex = Math.max(lastSavedStepIndex, INIT_INDEX_STEP);
    return lastSavedStepIndex;
}
//# sourceMappingURL=get-last-saved-step-index.js.map